import React, { useState, useEffect, Fragment } from 'react'
import { Form, Card, Button, Nav, Row, Col, Table, Tab } from 'react-bootstrap'
import callApi from '../../helpers/callapi'

const Withdrawal = () => {
  const [status, setStatus] = useState('all')

  const _status = [
    { title: 'ทั้งหมด', value: 'all' },
    { title: 'รอโอน', value: 'pending' },
    { title: 'โอนแล้ว', value: 'success' },
    { title: 'ยกเลิก', value: 'cancel' },
  ]
  const _headTable = ['วัน/เวลา', 'รหัสตัวแทน', 'ชื่อ', 'นามสกุล', 'จำนวนเงิน', 'สถานะ', 'ข้อมูลธนาคาร', ' ']

  const [loading, setLoading] = useState(false)
  const [withdrawals, setWithdrawals] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [userCount, setUserCount] = useState()
  const [searchText, setSearchText] = useState('')
  //const [status, setStatus] = useState("all");
  const [name, setName] = useState('')
  const [agentId, setAgentId] = useState('')

  const fetchWithdrawals = async (page, { status, agentId, name } = {}) => {
    try {
      setLoading(true)

      const query = {
        page: page || 1,
        name: name,
        agentId: agentId,
      }
      if (status !== 'all') {
        query.status = status
      }

      const { results: _withdrawals } = await callApi({
        url: '/withdrawals',
        query,
      })

      setWithdrawals(_withdrawals)
      setLoading(false)
    } catch (error) {
      console.log()
      // console.error('Error while trying to fetch withdrawals.', error);
      // message.error(error.message);
      setWithdrawals([])
      setUserCount(0)
      setLoading(false)
    }
  }
  console.log('withdrawals', withdrawals)

  useEffect(() => {
    fetchWithdrawals()
  }, [])
  return (
    <Fragment>
      <Card>
        <Card.Header>
          <Card.Title>ลูกค้า</Card.Title>
        </Card.Header>
        <Card.Body>
          <Tab.Container defaultActiveKey={_status[0].value}>
            <Nav as="ul" className="nav-pills mb-4 light">
              <span style={{ marginRight: '15px', marginTop: '13px' }}>Status: </span>
              {_status.map((data, i) => {
                return (
                  i !== _status.length && (
                    <Nav.Item as="li" key={i}>
                      <Nav.Link
                        eventKey={data.value}
                        onClick={async () => {
                          setStatus(data.value)
                          // fetchTransfers(1, undefined, data.value);
                        }}
                      >
                        {data.title}
                      </Nav.Link>
                    </Nav.Item>
                  )
                )
              })}
            </Nav>
          </Tab.Container>
          <Form>
            <Form.Group>
              <Row>
                <Col sm={12} md={6} lg={4}>
                  <Form.Control type="text" placeholder="ชื่อลูกค้า" />
                </Col>
                <Col sm={12} md={6} lg={4}>
                  <Form.Control type="text" placeholder="เบอร์โทรศัพท์/รหัสสมาชิก" />
                </Col>
                <Col sm={12} md={12} lg={4}>
                  <Row>
                    <Col md={6} lg={0}></Col>
                    <Col md={6} lg={12}>
                      <Button variant="danger light" className="w-50">
                        ล้างตัวกรอง
                      </Button>
                      <Button variant="primary light" className="w-50">
                        ค้นหา
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Form.Group>
          </Form>
          <Table responsive striped bordered className="verticle-middle">
            <thead>
              <tr>
                {_headTable.map((head, i) => {
                  return <td key={i}>{head}</td>
                })}
              </tr>
            </thead>
            <tbody>
              {withdrawals.map((agent, i) => {
                return (
                  <tr key={i}>
                    <td>{new Date(agent.createdAt).toLocaleString('th-TH')}</td>
                    <td>{agent.agentId}</td>
                    <td>{agent.firstName}</td>
                    <td>{agent.lastName}</td>
                    <td>{agent.amount.toFixed(2)}</td>
                    <td>{agent.status}</td>
                    <td>{agent.bankName}</td>
                    <td> </td>
                  </tr>
                )
              })}
            </tbody>
          </Table>
        </Card.Body>
      </Card>
    </Fragment>
  )
}

export default Withdrawal
